import {useTranslation} from 'react-i18next';
import {Button} from '@guestapp/ui';
import {useDispenserControls, useKioskoStore} from 'context/kiosko';
import styles from './styled.module.css';

type Props = {
  onClose: () => void;
  onMaybeLater: () => void;
};
function IncompletePrintedCardContent({onClose, onMaybeLater}: Props) {
  const {t} = useTranslation();
  const pending = useKioskoStore(state => state.cards.pending);
  const {printCard} = useDispenserControls();

  return (
    <>
      <div>
        <div className={styles.title}>{t('do_you_want_to_print_more_keycards')}</div>
        <div className={styles.subtitle}>
          {t('you_can_print_up_to_4_keycards', {pending})}
        </div>
      </div>

      <div className={styles.buttonContainer}>
        <Button
          label={t('print_new_keycard')}
          outlined
          onClick={() => {
            printCard();
            onClose();
          }}
        />
        <Button label={t('maybe_later')} outlined onClick={onMaybeLater} />
      </div>
    </>
  );
}

export {IncompletePrintedCardContent};
